







import { Component, Vue } from "vue-property-decorator";
export default class LogoSingle extends Vue {
  private logo = process.env.VUE_APP_AWS_ASSETS + "/logos/logo-uno.png";
}
